import { create } from 'zustand'
import { Player } from '../types'

interface PlayerState {
  player: Player | null
  isLoading: boolean
  error: string | null
  
  // Actions
  setPlayer: (player: Player) => void
  updateCash: (amount: number) => void
  loadPlayer: (playerId: string) => Promise<void>
  reset: () => void
}

export const usePlayerStore = create<PlayerState>((set) => ({
  player: null,
  isLoading: false,
  error: null,
  
  setPlayer: (player) => set({ player, error: null }),
  
  updateCash: (amount) => {
    set((state) => ({
      player: state.player ? {
        ...state.player,
        cash: state.player.cash + amount
      } : null
    }))
  },
  
  loadPlayer: async (playerId: string) => {
    set({ isLoading: true, error: null })
    
    try {
      const response = await fetch(`https://business-tycoon-worker.smnshzh.workers.dev/api/players/${playerId}`)
      if (!response.ok) {
        throw new Error('Failed to load player data')
      }
      
      const playerData: Player = await response.json()
      set({ player: playerData, isLoading: false })
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Unknown error',
        isLoading: false 
      })
    }
  },
  
  reset: () => set({ player: null, error: null, isLoading: false })
}))
